<template>
  <v-container
    fluid
    tag="section"
  >
    <v-row

      justify="center"
    >
      <v-col>
        <v-dialog
          v-model="dialogVisible"
          width="clamp(350px, 50%, 50%)"
          persistent
        >
          <v-card>
            <v-card-title class="display-2 font-weight-light">
              Начисление бонусов участнику
            </v-card-title>
            <v-card-subtitle>Счёт: {{ account.Account }}</v-card-subtitle>
            <v-card-text>
              <v-row>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    v-model="newAmount"
                    type="number"
                    label="Бонусы"
                    hint="Добавьте необходимое количество бонусов участнику"
                  />
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider />
            <v-card-actions class="d-flex justify-center align-center">
              <v-btn
                color="blue lighten-5 blue--text text--darken-1"
                @click="onCashin"
              >
                Добавить
              </v-btn>
              <v-btn
                color="primary"
                outlined
                @click="$emit('close')"
              >
                Закрыть
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AccountListViewModel from "@/views/loyalty/models/account-list-view.model"
import { AccountService } from "@/views/loyalty/shared/services/account-service"

export default {
  name: "UserProfileAccountEdit",
  components: { },
    props: ['campaignId', 'dialogVisible', 'userProfile'],
  data: () => ({
      account: Reflect.construct(AccountListViewModel, []),
      accountService: null,
      newAmount: 0,
  }),
    watch: {
      dialogVisible: {
          async handler (newValue, oldValue) {
              if (newValue) {
                  await this.getItems()
              }
          }
      }
    },
  async beforeMount () {
      this.accountService = new AccountService()
  },
  methods: {
    async getItems () {
        this.account = await this.accountService.getParticipantAccount(this.campaignId, this.userProfile.userProfileId)
        console.log('account', this.account)
        this.newAmount = this.account.amount
    },
      async onCashin () {
        // console.log('Cashin')
        //   console.log('newAmount', this.newAmount)
          await this.accountService.participantCashin(this.campaignId, this.userProfile.userProfileId, this.newAmount)
          this.$emit('added')
      },
  }
}
</script>

<style scoped></style>
